import React, { useState } from 'react';
import './MSBTE.css'; 

const MSBTE = () => {
   
    const [selectedPdfUrl, setSelectedPdfUrl] = useState(null);

   
    const msbteApprovalPdfUrl = "/msbte-affilition_page-0001 (1).pdf";

   
    const openPdfViewer = (pdfUrl) => {
        setSelectedPdfUrl(pdfUrl);
    };

   
    const closePdfViewer = () => {
        setSelectedPdfUrl(null);
    };

    return (
        <div className="msbte-page-container">
            <h2>Maharashtra State Board of Technical Education (MSBTE)</h2>
            <p className="msbte-intro-text">
                
            </p>
            
            <div className="msbte-document-section">
                <button
                    className="view-document-btn"
                    onClick={() => openPdfViewer(msbteApprovalPdfUrl)}
                >
                    Click to View Document
                </button>
            </div>

          
            {selectedPdfUrl && (
                <div className="fullscreen-overlay" onClick={closePdfViewer}>
                    <button className="close-button" onClick={closePdfViewer}>&times;</button>
                    <iframe
                        className="pdf-viewer-iframe"
                        src={`${selectedPdfUrl}#toolbar=0`}
                        title="MSBTE Approval Document"
                        frameBorder="0"
                    />
                </div>
            )}
        </div>
    );
};

export default MSBTE;